var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10h24a2 2 0 000-4H4a2 2 0 000 4zm24 4H4a2 2 0 000 4h24a2 2 0 000-4zm0 8H4a2 2 0 000 4h24a2 2 0 000-4z"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBmaWxsPSJjdXJyZW50Q29sb3IiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMyIDMyIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtNCAxMGgyNGMxLjEwNCAwIDItMC44OTYgMi0ycy0wLjg5Ni0yLTItMmgtMjRjLTEuMTA0IDAtMiAwLjg5Ni0yIDJzMC44OTYgMiAyIDJ6bTI0IDRoLTI0Yy0xLjEwNCAwLTIgMC44OTYtMiAyczAuODk2IDIgMiAyaDI0YzEuMTA0IDAgMi0wLjg5NiAyLTJzLTAuODk2LTItMi0yem0wIDhoLTI0Yy0xLjEwNCAwLTIgMC44OTYtMiAyczAuODk2IDIgMiAyaDI0YzEuMTA0IDAgMi0wLjg5NiAyLTJzLTAuODk2LTItMi0yeiIvPjwvc3ZnPgo=";
export { SvgHamburger as ReactComponent };